
import React from 'react';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import './ImagePopup.scss';
// const ImagePopup = ({ imageUrl, onClose, onDownload }) => {
const ImagePopup = ({ imageUrl, onClose }) => {
  const handleDownload = async () => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      // Create a temporary URL for the blob
      const url = URL.createObjectURL(blob);
      // Create a link element and trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.download = 'image.jpg';
      link.click();
      // Clean up the temporary URL
      URL.revokeObjectURL(url);
    } catch (error) {

    }
  };
  return (
    <div className="modal-background">
      <div className="modal-content-image">
        <div className="icon-container">
          <IconButton variant="none" size="small" title='Download Image' aria-label="Download Image"
            style={{ marginRight: '10px' }}
            onClick={handleDownload} >
            <img src={require("../../assets/img/download-icon.webp")} alt="download"
                  loading="lazy" /></IconButton>
          <IconButton
            variant="outlined"
            size="small"
            title="Close"
            aria-label="Close"
            onClick={onClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
        <div className="image-container">
          <img src={imageUrl} alt="Popup" className="popup-image"
                  loading="lazy" />
        </div>
      </div>
    </div>
  );
};
export default ImagePopup;


